import { AnimatePresence, motion } from 'framer-motion'
import { Button } from './Button'
import { usePreview } from '../../context/usePreview'

const KIND_LABEL: Record<string, string> = {
  THEME: 'theme',
  BACKGROUND: 'background',
  SOUNDSCAPE: 'soundscape',
  AVATAR: 'avatar',
}

/**
 * App-wide banner for an active cosmetic preview. Mounted once near the root
 * so the countdown + Stop control stays visible no matter which screen the
 * user navigates to while the 10s preview is running.
 */
export const PreviewStatusBar = () => {
  const { activePreview, remainingMs, cancelPreview } = usePreview()

  return (
    <div className="pointer-events-none fixed inset-x-0 top-4 z-[100] flex justify-center px-4">
      <AnimatePresence>
        {activePreview && (
          <motion.div
            role="status"
            aria-live="polite"
            initial={{ opacity: 0, y: -12, scale: 0.96 }}
            animate={{ opacity: 1, y: 0, scale: 1 }}
            exit={{ opacity: 0, y: -8, scale: 0.96 }}
            transition={{ duration: 0.18, ease: 'easeOut' }}
            className="pointer-events-auto flex items-center gap-3 rounded-xl border border-[color-mix(in_srgb,var(--accent)_40%,transparent)] bg-[color-mix(in_srgb,var(--surface-raised)_90%,transparent)] px-4 py-2.5 text-sm font-medium text-[var(--accent-strong)] shadow-[var(--shadow-pop)] backdrop-blur-xl"
          >
            <span className="grid h-5 w-5 place-items-center rounded-full border border-current/30 text-[11px]" aria-hidden="true">👁</span>
            <span>
              Previewing {KIND_LABEL[activePreview.kind] ?? 'item'} <strong>{activePreview.label}</strong> — {Math.ceil(remainingMs / 1000)}s
            </span>
            <Button
              variant="tertiary"
              size="sm"
              onClick={cancelPreview}
            >
              Stop
            </Button>
          </motion.div>
        )}
      </AnimatePresence>
    </div>
  )
}
